import { COPY_GENERIC } from './GENERIC';

export const COPY_SPECIFIC = {
	ACCEPT: 'Accept',
	ACCEPT_INVITATION: 'Accept Invitation',
	ACCESS_AUDIT: 'Access Audit',
	ACCESS_CHANGES_DETECTED: 'Access Changes Detected',
	ACCESS_COMPARISON: 'Access Comparison',
	ACCESS_EXPLAINER: 'Access Explainer',
	ACCESS_LEVEL: 'Access Level',
	ACCESS_LOG: 'Access Log',
	ACCESS_NAME: 'Access Name',
	ACCESS_OBJECT_SOURCE: 'Access Object Source',
	ACCESS_TYPE: 'Access Type',
	ACCESS_TYPES: 'Access Types',
	ACCOUNT_INFORMATION: 'Account Information',
	ACTION: 'Action',
	ACTIVE: 'Active',
	ACTOR: 'Actor',
	ADD_APP_SETTINGS: 'App Settings',
	ADD_A_FILE: 'Add a File',
	ADD_A_LINK: 'Add a Link',
	ADD_A_NEW_APP: 'Add a New App',
	ADD_A_NEW_STAKEHOLDER: 'Add a New Stakeholder',
	ADD_A_NEW_USER: 'Add a New User',
	ADD_CONDITION: 'Add Condition',
	ADD_CUSTOMER: 'Add Customer',
	ADD_FILTERS: 'Add Filters',
	ADD_GROUP: 'Add Group',
	ADD_NEW_APP: 'Add New App',
	ADD_NEW_AROVY_USER: 'Add New Arovy User',
	ADD_NEW_STAKEHOLDER: 'Add New Stakeholder',
	ADD_NEW_USER: 'Add New User',
	ADD_PERMISSION_OBJECT: '+ Add Permission Object',
	ADD_STAKEHOLDERS: 'Add Stakeholders',
	ADD_TASK: 'Add Task',
	ADD_TO_A_TASK: 'Add to a task?',
	ADD_TO_INITIATIVE: 'Add to Initiative',
	ADD_TO_TAG: 'Add to Tag',
	ADD_TO_TASK: 'Add to Task',
	ADMINISTRATION: 'Administration',
	ADMIN_IMPERSONATOR_MODE: 'ADMIN: Impersonator Mode',
	ADVANCED: 'Advanced',
	AGENT_ACCESS: 'Agent Access',
	AI_CONTEXT: 'AI Context',
	AI_CONTEXT_SUBTITLE: 'Organization knowledge injected into every AI interaction across Arovy.',
	AI_EXPLAIN: 'AI Explain',
	AI_FIX: 'AI Fix',
	AI_GENERATING_CONTENT: 'AI is generating your content...',
	AI_GENERATING_DESCRIPTIONS_IN_BACKGROUND: 'Generating AI descriptions in the background',
	AI_GENERATION_COMPLETE_TOOLTIP: 'Documentation complete for selected fields. You\'re all set!',
	AI_GENERATION_DEFAULT_TOOLTIP: 'Generate AI content for this column.',
	AI_PREPARING_DATA_DICTIONARY_SUBTITLE: 'Arovy is analyzing your Salesforce metadata for AI processing',
	AI_PREPARING_DATA_DICTIONARY_TITLE: 'Preparing Your Data Dictionary',
	AI_PREPARING_FIELD_ANALYSIS: 'Preparing field analysis...',
	AI_PROCESSING_IN_BACKGROUND: 'Processing in Background',
	AI_PROMPT_LENGTH_ERROR:
	'Too many changes selected. Please selected a smaller date range or filters to limit the amount of changes.',
	AI_RESPONSE_FAILURE: (supportEmailAddress: string) =>
		// eslint-disable-next-line max-len
		`We're having trouble generating a response right now. Please close the modal and try again. If you continue to see this error, please contact support at <a href="mailto:${supportEmailAddress}">${supportEmailAddress}</a>`,
	AI_TASK_ANALYZING_METADATA_DESCRIPTION: 'Preparing field analysis...',
	AI_TASK_ANALYZING_METADATA_TITLE: 'Analyzing Metadata Structure',
	AI_TASK_GENERATING_CONTEXT_DESCRIPTION:
	'Collecting field dependencies, business logic, and validation rules for the Agent to use during the process.',
	AI_TASK_GENERATING_CONTEXT_TITLE: 'Generating Context For The Agent',
	AI_TASK_INITIALIZING_ENGINE_DESCRIPTION:
	'Preparing context-aware generation with field-specific terminology for maximum clarity.',
	AI_TASK_INITIALIZING_ENGINE_TITLE: 'Initializing AI Documentation Engine',
	AI_TASK_VALIDATING_UTILIZATION_DESCRIPTION:
	'Checking automation touchpoints, and integration usage across all connected systems.',
	AI_TASK_VALIDATING_UTILIZATION_TITLE: 'Validating Field Utilization',
	ALERTED: 'Alerted',
	ALERT_TO_CHANGES: 'Alert to Changes',
	ALL: 'All',
	ALL_APPS_MONITORED: 'Great job, all apps are being monitored.',
	ALL_CONDITIONS_ARE_MET: 'All Conditions Are Met (AND)',
	ALL_OTHERS: 'All Others',
	AND: 'And',
	ANY: 'Any',
	ANY_APPLICATION: 'Any Application',
	ANY_COMPLIANCE_CATEGORY: 'Any Compliance Category',
	ANY_CONDITIONS_ARE_MET: 'Any Conditions Are Met (OR)',
	ANY_LABELED: (label: string | null | undefined): string => `Any ${label ?? 'Any'}`,
	ANY_TAG: 'Any Tag',
	APEX: 'Apex',
	API_CALLS: 'Api Calls',
	API_DOWNTIME: 'Api Downtime',
	API_KEYS: 'API Keys',
	API_KEY_COPIED: 'API key copied to clipboard',
	API_KEY_CREATED_SUCCESSFULLY: 'API key created. Please wait a few minutes for it to activate',
	API_KEY_DELETED_SUCCESSFULLY: 'API key deleted successfully',
	API_KEY_FAILED_TO_CREATE: 'API key failed to create',
	API_KEY_FAILED_TO_DELETE: 'API key failed to delete',
	API_KEY_FAILED_TO_UPDATE: 'API key failed to update',
	API_KEY_TOKEN: 'Api Key / Token',
	API_KEY_UPDATED_SUCCESSFULLY: 'API key updated successfully',
	API_NAME: 'API Name',
	API_VERSION: 'Api Version',
	API_VOLUME_EXPLORER: 'API Volume Explorer',
	APP: 'App',
	APPLICATION: 'Application',
	APPLICATIONS: 'Applications',
	// eslint-disable-next-line max-len
	APPLICATION_CURRENTLY_BLOCKED: 'Application currently blocked and may be compromised. If access changes are not expected, consider blocking in Salesforce.',
	APPLICATION_EXPLORER: 'Application Explorer',
	APPLICATION_MONITORING: 'Application Monitoring',
	APPLICATION_OVERVIEW: 'Application Overview',
	APPLICATION_SETUP: 'Application Setup',
	APPLICATION_STATUS: 'Application Status',
	APPLY_FILTERS: 'Apply Filters',
	APPLY_PACKAGE_DEFAULTS: 'Apply package defaults',
	APPROVE: 'Approve',
	ARCHIVE: 'Archive',
	ARCHIVED_ISSUES: 'Archived Issues',
	ARCHIVE_INITIATIVE: 'Archive Initiative',
	ARE_YOU_SURE_ARCHIVE_INITIATVE: 'Are you sure you would like to archive this initiative?',
	ARE_YOU_SURE_ARCHIVE_INITIATVES: 'Are you sure you want to archive {0} initiatives?',
	ARE_YOU_SURE_DELETE_SCOPE: (count: number, name: string) =>
		`Are you sure you want to remove ${count} ${name} from this initiative?`,
	ARE_YOU_SURE_DELETE_VIEW:
	// eslint-disable-next-line max-len
	'Are you sure you want to delete this view? Any published views will no longer display any Data Dictionary information.',
	ARE_YOU_SURE_REMOVE_PACKAGE_TAGGING:
	// eslint-disable-next-line max-len
	'Are you sure you want to disable Package Tagging? All package tags will be deleted, and all fields will have their package tags removed.',
	AROVY: 'Arovy',
	AROVY_AI_GENERATED: 'Arovy AI Generated',
	AROVY_USERS: 'Arovy Users',
	ASSIGNED_TO_ME: 'Assigned To Me',
	ATTACHED_FILES: 'Attached Files',
	AUTOMATION_RULE_INFORMATION: 'Automation Rule Information',
	AVAILABLE_FOR_USE: 'Available For Use',
	A_LOOKUP_ON_OBJECT: 'A lookup on the {0} object',
	BACK: 'Back',
	BACK_TO_LOGIN: 'Back to Login',
	BASIC: 'Basic',
	BLOCKED: 'Blocked',
	BLOCK_APPLICATIONS_NEW_OBJECTS: 'Block application when it attempts to access new objects',
	BLOCK_IN_SALESFORCE: 'Block in Salesforce',
	BODY_PLAIN_TEXT_PREVIEW: 'Body (Plain Text Preview)',
	BOUNCE: 'Bounce',
	BROWSER_CLIENT_LIBRARY: 'Browser / Client Library',
	BULK_EDIT: 'Bulk Edit',
	BULK_TAG: 'Bulk Tag',
	BUSINESS_CONTEXT: 'Business Context',
	CAMPAIGN: 'Campaign',
	CANCEL: 'Cancel',
	CC_EMAILS: 'CC Emails',
	CHANGE: 'Change',
	CHANGES: 'Changes',
	CHANGES_COUNT: (count:number) => `${count} Changes`,
	CHANGES_FROM: 'Changes from: ',
	CHANGES_SYNC_TO_SALESFORCE: 'Changes in this column sync directly to Salesforce',
	CHANGE_DETAIL: 'Change Detail',
	CHANGE_DETECTED_ON: 'Change detected on',
	CHANGE_OWNER: 'Change Owner',
	CHANGE_PASSWORD: 'Change Password',
	CHANGE_STATUS: 'Change Status',
	CLASSIFICATION: 'Classification',
	CLEAR_AI_TEXT: 'Clear AI Text',
	CLEAR_ALL: 'Clear All',
	CLEAR_ENTITY_FILTERS: 'Clear Entity Filters',
	CLEAR_FILTERS: 'Clear Filters',
	CLEAR_SELECTION: 'Clear Selection',
	CLICK_OR_DRAG_FILE_TO_THIS_AREA_TO_UPLOAD: 'Click or drag file to this area to upload',
	CLICK_TO_ADD_LINKS_AND_FILES_TO_INITIATIVE: 'Click the buttons above to add links and files to the initiative',
	CLICK_TO_COPY: 'Click to copy',
	CLIENT_FAMILY: 'Client Family',
	CLIENT_MAJOR: 'Client Major',
	CLIENT_VERSION: 'Client Version',
	COLOR: 'Color',
	COLUMNS: 'Columns',
	COMMENTS: 'Comments',
	COMPARE: 'Compare',
	COMPLETE: 'Complete',
	COMPLIANCE: 'Compliance',
	COMPLIANCE_CATEGORIES: 'Compliance Categories',
	COMPLIANCE_CATEGORY: 'Compliance Category',
	CONDITION: 'Condition',
	CONDITION_LOGIC: 'Condition Logic',
	CONFIG: 'Config',
	CONFIGURATION: 'Configuration',
	CONFIGURE_ORGANIZATIONS: COPY_GENERIC.CONFIGURE('Organizations'),
	CONFIGURE_TAGS: COPY_GENERIC.CONFIGURE('Tags'),
	CONFIRM_ARCHIVE_INITIAIVE: 'Confirm Archive Initiative',
	CONNECT: 'Connect',
	CONNECTED: 'Connected',
	CONNECTED_AGENTS: 'Connected Agents',
	CONNECTED_APPLICATION: 'CA',
	CONNECTED_APPLICATIONS: 'Connected Apps',
	CONNECT_YOUR_INSTANCE: 'Connect Your Instance',
	CONTACT_AROVY_ADMIN: 'Contact your Arovy Admin for help',
	CONTACT_SUPPORT: 'Contact Support',
	CONTACT_US: 'Contact Us',
	CONTAINS: 'Contains',
	CONTENT_TYPE: 'Content Type',
	CONTINUE: 'Continue',
	CONTROLS: 'Controls',
	COPIED: 'Copied',
	COPYING: 'Copying...',
	COPY_FAILED: 'Copy Failed',
	COPY_TO_CLIPBOARD: 'Copy to Clipboard',
	COUNTRY: 'Country',
	COUNTRY_ISO: 'Country ISO',
	CREATE: 'Create',
	CREATED: 'Created',
	CREATED_AT: 'Created At',
	CREATED_BY: 'Created By',
	CREATED_DATE: 'Created Date',
	CREATE_API_KEY: 'Create Your First Key',
	CREATE_API_KEY_DESCRIPTION: 'Create your first API key to start using the Data Dictionary programmatically.',
	CREATE_AROVY_ACCOUNT: 'Create Arovy Account',
	CREATE_INITIATIVE: 'Create Initiative',
	CREATE_MONITOR: 'Create Monitor',
	CREATE_MONITOR_UPSELL_BODY: 'Track what matters most. Create custom monitors for proactive insights.',
	CREATE_MONITOR_UPSELL_TITLE: 'Stay Ahead with Custom Monitors!',
	CREATE_NEW_INITIATIVE: 'Create New Initiative',
	CREATE_NEW_KEY: 'Create New Key',
	CREATE_NEW_MONITOR: 'Create New Monitor',
	CREATE_NEW_TAG: 'Create New Tag',
	CREATE_NEW_TASK: 'Create New Task',
	CREATE_TAG: 'Create Tag',
	CREATE_TAGS: 'Create Tags',
	CREATING_EMBEDDABLE_LINK: 'Creating an Embeddable Link',
	CRITERIA: 'Criteria',
	CRM_VISIBLE: 'CRM Visible',
	CRUNCHING_THE_NUMBERS: 'Crunching the numbers',
	CUSTOM: 'Custom',
	CUSTOMER_VIEW: 'Customer View',
	CUSTOM_CONDITION_LOGIC_IS_MET: 'Custom Condition Logic is Met',
	CUSTOM_LOGIC: 'Custom Logic',
	DASHBOARD: 'Dashboard',
	DATA_ACCESS: 'Data Access',
	DATA_DICTIONARY: 'Data Dictionary',
	DATA_GOVERNANCE: 'Data Governance',
	DATA_LAST_SYNCED_TODAY: 'Your data was last synced today.',
	DATA_ONE_DAY_OLD: 'Your data is 1 day old.',
	DATA_OUT_OF_DATE: 'Data is out of date, click Refresh Data to see updated results.',
	DATA_SECURITY: 'Data Security',
	DATA_SENSITIVITY: 'Data Sensitivity',
	DATE: 'Date',
	DECLINE: 'Decline',
	DEFAULT_VIEW: 'Default View',
	DEFINITION: 'Definition',
	DELEGATE_USER: 'Delegate User',
	DELETE: 'Delete',
	DELETED: 'Deleted',
	DELETE_API_KEY: 'Delete API Key',
	DELETE_API_KEY_CONFIRMATION: 'Are you sure you want to delete this API key? This action cannot be undone.',
	DELETE_INTEGRATION: 'Delete Integration',
	DENY: 'Deny',
	DEPLOYMENT_STATUS: 'Deployment Status',
	DESCRIBE_YOUR_INITIATIVE: 'Describe Your Initiative',
	// eslint-disable-next-line max-len
	DESCRIBE_YOUR_INITIATIVE_TOOLTIP: `💡 Pro tip: The more specific you are, the more actionable your results. Think of this as briefing a trusted colleague. Include details like:
Your objective and success metrics
Teams or stakeholders involved
Any compliance or security considerations`,
	DESCRIPTION: 'Description',
	DETAILED_LIST_OF_CHANGES: 'Detailed List of Changes',
	DETAILS: 'Details',
	DETECTED_APPLICATIONS: 'Detected Applications',
	DETECTED_DATE: 'Detected Date',
	DIAGNOSTICS: 'Diagnostics',
	DISABLED_CUSTOMERS_COUNT: (count: number) => `${count} Disabled Customers`,
	DISCONNECT: 'Disconnect',
	DISPLAY_NAME: 'Display Name',
	DONE: 'Done',
	DOWNLOAD_FIELDSPY:
		// eslint-disable-next-line max-len
		'Population percentage is available for objects that have been analyzed with FieldSpy. <a target="_blank" rel="noopener norefererr" href="https://appexchange.salesforce.com/appxListingDetail?listingId=a0N3u00000QsXfSEAV">Click here</a> to download the package from the Salesforce AppExchange.',
	EDIT: 'Edit',
	EDITING: 'Editing',
	EDITING_LABEL: (label:string) => `Editing ${label}`,
	EDIT_APP: 'Edit App',
	EDIT_SETTINGS: 'Edit Settings',
	EDIT_TAGS: 'Edit Tags',
	EMAIL: 'Email',
	EMAIL_INFORMATION: 'Email Information',
	EMAIL_IN_USE: 'Email is already in use. Please try another.',
	EMAIL_NOTIFICATIONS: 'Email Notifications',
	EMAIL_TEMPLATE_INFORMATION: 'Email Template Information',
	EMPTY: 'Empty',
	ENABLED_CUSTOMERS: 'Enabled Customers',
	ENABLED_CUSTOMERS_COUNT: (count: number) => `${count} Enabled Customers`,
	ENABLE_ALL: 'Enable all',
	ENABLE_BY_DEFAULT: 'Enable by Default',
	ENABLE_REPORTS: 'Enable Reports',
	ENTITIES: 'Entities',
	ENTITY_OWNER: 'Entity Owner',
	ENTITY_STAKEHOLDER: 'Entity Stakeholder',
	EQUALS: 'Equals',
	ERROR: 'Error',
	EVALUATION_CRITERIA: 'Evaluation Criteria',
	EVENT: 'Event',
	EVENT_DATE: 'Event Date',
	EVENT_IDENTIFIER: 'Event Identifier',
	EVERYTHING_LOOKS_GREAT: 'Everything looks great!',
	EXCLUDE_EMPTY_VALUES: 'Exclude empty values',
	EXCLUDE_WEEKENDS_FROM_BASELINE: 'Exclude weekends from baseline',
	EXCLUDING_EMPTY: 'Excluding Empty',
	EXIT: 'Exit',
	EXPLORE: 'Explore',
	EXPORT: 'Export',
	EXTERNAL_AI_AGENTS: 'External AI Agents and devices that can read your Arovy data over MCP.',
	EXTERNAL_CLIENT_APPLICATION: 'ECA',
	EXTERNAL_CLIENT_APPLICATIONS: 'External Client Apps',
	EXTERNAL_LINKS: 'External Links',
	EXTRACTING_CONTENT_FROM: 'Extracting content from ',
	FAILED_TO_GENERATE_PDF: 'Failed to generate PDF.',
	FEATURE_FLAGS: 'Feature Flags',
	FEATURE_FLAG_GROUP: 'Feature Flag Group',
	FIELD: 'Field',
	FIELDS: 'Fields',
	FIELD_ACCESS: 'Field Access',
	FIELD_CANNOT_EXCEED: (fieldName: string, max: number) => `${fieldName} cannot exceed ${max} characters`,
	FIELD_COUNT: 'Field Count',
	FIELD_INFORMATION: 'Field Information',
	FIELD_NAME: 'Field Name',
	FIELD_REQUIRED: (fieldName: string) => `${fieldName} is required`,
	FIELD_TO_UPDATE: 'Field to Update',
	FIELD_TYPE: 'Field Type',
	FIELD_USAGE: 'Field Usage',
	FILE_IS_TOO_LARGE: (maxSize: number) => `File is too large. Must be less than ${maxSize / 1024 / 1024}MB.`,
	// eslint-disable-next-line max-len
	FILE_PROCESSING_ERROR: 'There was an issue processing the provided file. Ensure that it is an accepted type and no more than 5MB, and try again.',
	FILTERS: 'Filters',
	FILTERS_ADVANCED_CONTINUE: 'Switching to Advanced filters will clear your current selections. Continue?',
	FILTERS_APPLIED: 'Filters applied',
	FILTERS_BASIC_CONTINUE: 'Switching to Basic filters will clear your current selections. Continue?',
	FILTER_HIDDEN: 'Filter Hidden',
	FINGERPRINT_ANOMALIES: 'Fingerprint Anomalies',
	FIRST_NAME: 'First Name',
	FOLDER: 'Folder',
	FOLLOW: 'Follow',
	FOLLOWING: 'Following',
	FORGOT_PASSWORD: 'Forgot Password',
	FORMULA: 'Formula',
	FORMULA_REFERENCES_FIELDS: 'Formula references {0} fields:',
	GENERATE: 'Generate',
	GENERATE_LINK: 'Generate Link',
	GETTING_DATA_FROM_SALESFORCE: 'Getting data from Salesforce',
	GLOBAL_MUTE: 'Global Mute',
	GOOGLE: 'Google',
	GO_TO_DICTIONARY: 'Go to Dictionary',
	GO_TO_SETTINGS: 'Go to Settings',
	GROUP: 'Group',
	GROUPS: 'Groups',
	GROUP_BY: 'Group By:',
	HELPFUL: 'Helpful',
	HELP_CENTER: 'Help Center',
	HELP_TEXT: 'Help Text',
	HERE: 'here',
	HIDDEN: 'Hidden',
	HIDE: 'Hide',
	HIDE_LIST: 'Hide List',
	ID: 'ID',
	IMPACTED_APPLICATIONS: 'Impacted Applications',
	IMPACT_ANALYSIS: 'Impact Analysis',
	INACTIVE: 'Inactive',
	INCIDENT_LOG: 'Incident Log',
	INCLUDE_FIELDS_WITHOUT_DIFFERENCES: 'Include Fields Without Differences',
	INCLUDE_OBJECTS_WITHOUT_DIFFERENCES: 'Include Objects Without Differences',
	INDIVIDUAL: 'Individual',
	INITIATIVE: 'Initiative',
	INITIATIVES: 'Initiatives',
	INITIATIVES_SELECTED: 'initiatives selected',
	INITIATIVE_NAME: 'Initiative Name',
	INSTALLED: 'Installed',
	INTEGRATED_APPS: 'Integrated Apps',
	INTEGRATED_APP_USAGE: 'Integrated App Usage',
	INTEGRATIONS: 'Integrations',
	INTEGRATION_USER: 'Integration User',
	INVALID_LINK: 'Invalid Link',
	INVESTIGATE: 'Investigate',
	INVITED: 'Invited',
	INVITE_USER: 'Invite User',
	IP_LOCATION: 'IP / Location',
	IP_RANGE: 'IP Range',
	ISSUER: 'Issuer',
	ISSUES: 'Issues',
	ISSUES_SUMMARY: 'Issues Summary',
	IS_ANY: 'Is Any',
	IS_READ_ONLY: 'Is Read Only',
	ITEMS: 'Items',
	JIRA: 'Jira',
	JIRA_INCOMPLETE_STATUS: 'Some of the Jira statuses aren\'t mapped to an Arovy Status. ',
	JIRA_INTEGRATION: 'Jira Integration',
	JIRA_ISSUES: 'Jira Issues',
	JIRA_SET_UP_MAPPING: ' to set up a mapping',
	JIRA_UNMAPPED_STATUS: 'This status isn\'t mapped to an Arovy Status. ',
	LABEL: 'Label',
	LANDING_PAGE_INFORMATION: 'Landing Page Information',
	LAST_ACTIVE: 'Last Active',
	LAST_MODIFIED_BY: 'Last Modified By',
	LAST_MODIFIED_DATE: 'Last Modified Date',
	LAST_NAME: 'Last Name',
	LAST_RUN_DATE: 'Last Run Date',
	LAST_SYNC_SUMMARY: 'Last Sync Summary',
	LAST_UPDATED_LABEL: (date: string) => `Last Updated on ${date}`,
	LAST_USED: 'Last Used',
	LEARN_MORE: 'Learn More',
	LINK: 'Link',
	LINK_EXPIRED: 'Link Expired',
	LINK_EXPIRED_DESCRIPTION: (supportEmailAddress: string) =>
		// eslint-disable-next-line max-len
		`The link you followed has expired. Invitations automatically expire after 48 hours. Please contact the sender for a new invitation link, or reach out to <a href="mailto:${supportEmailAddress}">${supportEmailAddress}</a>`,
	LINK_NEW_ORGANIZATION: 'Link New Organization',
	LIST_INFORMATION: 'List Information',
	LOCKED: 'Locked',
	LOCK_USER: 'Lock User',
	LOGGED: 'Logged',
	LOGIN: 'Login',
	LOGIN_HISTORY_ID: 'Login History ID',
	LOGOUT: 'Logout',
	MANAGE: 'Manage',
	MANAGED: 'Managed',
	MANAGE_API_KEYS: 'Manage API keys for programmatic access to the Data Dictionary.',
	MATCH_TYPE: 'Match Type',
	MAX_MONITORS_REACHED: 'This application already has a monitor of this type',
	MERGED_BUSINESS_CONTEXT_END: ' -- review before saving:',
	MERGED_BUSINESS_CONTEXT_START: 'Merged business context from ',
	MERGING_WITH_EXISTING_BUSINESS_CONTEXT: 'Merging with existing business context...',
	METADATA_BLUEPRINT: 'Metadata Blueprint',
	METADATA_IMPORT: 'Metadata Import',
	METADATA_IMPORT_LOGS: 'Metadata Import Logs',
	METADATA_TIMELINE: 'Metadata Timeline',
	MINIMUM_PACKAGE_TIER: 'Minimum Package Tier',
	MIXED: 'Mixed',
	MODIFIED_BY: 'Modified By',
	MODIFY_ALL_DATA: 'Modify All Data',
	MONITORED_APPLICATIONS: 'Monitored Applications',
	MONITORS: 'Monitors',
	MONITORS_AND_LOGS: 'Monitors and Logs',
	MONITOR_APP: 'Monitor App',
	MONITOR_BUILDER: 'Monitor Builder',
	MONITOR_DETAILS: 'Monitor Details',
	MONITOR_SETTINGS: 'Monitor Settings',
	NAME: 'Name',
	NEED_HELP_CREATING_API_TOKEN: 'Need help creating an API Token?',
	NEW_LABEL: (label: string) => `New ${label}`,
	NEW_VALUE: 'New Value',
	NEXT: 'Next',
	NEXT_WEEK: 'Next Week',
	NO: 'No',
	NONE: 'None',
	NONE_PARENTHETICAL: '(none)',
	NOT: 'Not',
	NOTES: 'Notes',
	NOTIFICATION_FREQUENCY: 'Notification Frequency',
	NOT_HELPFUL: 'Not Helpful',
	NOT_IN_PACKAGE: 'NOT IN PACKAGE',
	NOT_MANAGED: 'Not Managed',
	NOT_MONITORED: 'Not Monitored',
	NOT_MONITORED_TOOLTIP_END: ' to start monitoring this entity.',
	NOT_MONITORED_TOOLTIP_START:
	// eslint-disable-next-line max-len
	'This entity is not currently being monitored by Arovy. Add additional objects to the Integrated Apps configuration ',
	NO_ACCESS_AUDIT_DATA: 'No profiles or permission sets grant access to fields on this object.',
	NO_ACCESS_NAME: 'No access name',
	NO_API_KEYS_YET: 'No API keys yet.',
	NO_APPLICATION: 'No Application',
	NO_CHANGES_MADE_DURING_TIMEFRAME: 'No changes made during this timeframe',
	NO_CLASSIFICATION: 'No Classification',
	NO_COMPLIANCE_CATEGORIES: 'No Compliance Categories',
	NO_CONNECTED_APPS: 'No Connected Applications',
	NO_DATA_FOR_LABEL: (label:string) => `No Data for "${label}"`,
	NO_DATA_IMPORTED_LINE_1: 'Arovy hasn\'t imported data for this Salesforce field yet.',
	NO_DATA_IMPORTED_LINE_2: 'If you believe this is an error, please contact your administrator.',
	NO_GROUPS: 'No Groups',
	NO_ISSUES_ARCHIVED: 'There are no archived issues.',
	NO_ISSUES_SNOOZED: 'There are no snoozed issues.',
	NO_ISSUES_TO_REPORT: 'There are no issues to report.',
	NO_LABELED: (label: string | null | undefined): string => `No ${label ?? ''}`,
	NO_LAYOUTS: 'No Layouts',
	NO_OWNER: 'No Owner',
	NO_PREFIX: 'No Prefix',
	NO_PROFILE: 'No Profile',
	NO_RESULTS_FOUND: 'No results found. Try adjusting your search term',
	NO_SECTION: 'No Section',
	NO_SECTIONS_AVAILABLE: 'No Sections Available',
	NO_STAKEHOLDERS: 'No Stakeholders',
	NO_TAGS: 'No Tags',
	NO_UNMONITORED_APPS_FOUND: 'No unmonitored applications found.',
	NUMBER_SELECTED: (num: number): string => `${num} Selected`,
	OBJECT: 'Object',
	OBJECTS: 'Objects',
	OBJECT_ACCESS: 'Object Access',
	OBJECT_AND_FIELD_USAGE_ACTIVITY: 'Object & Field Usage Activity',
	OBJECT_NAME: 'Object Name',
	OK: 'Ok',
	OKTA: 'Okta',
	OLD_VALUE: 'Old Value',
	ONE_MONTH: 'One Month',
	OPEN_IN_SALESFORCE: 'Open in Salesforce',
	OPERATION: 'Operation',
	OPERATIONAL: 'Operational',
	OPERATOR: 'Operator',
	OR: 'Or',
	ORGANIZATION: 'Organization',
	ORGANIZATION_PREFERENCES: 'Organization Preferences',
	OTHER_ADD_ONS: 'Other / Add-ons',
	OUTAGE: 'Outage',
	OVERVIEW: 'Overview',
	OWNER: 'Owner',
	OWNERS: 'Owners',
	OWNERS_IMPACTED: 'Owners Impacted',
	PACKAGE: 'Package',
	PACKAGE_TAGGING: 'Package Tagging',
	PACKAGE_TIER: 'Package Tier',
	PAGE_ACTION_INFORMATION: 'Page Action Information',
	PAGE_URL: 'Page URL',
	PARDOT_IS_SYNCING: 'Pardot is syncing',
	PARENT_OBJECT: 'Parent Object',
	PERFORMANCE_OVERVIEW: 'Performance Overview',
	PERFORM_ACTIONS_ON_TEXT_FIELDS: 'Perform Actions on Text Fields',
	PERMISSIONS: 'Permissions',
	PERMISSION_SET: 'Permission Set',
	PERMISSION_SOURCE: 'Permission Source',
	PERSONAL_INFO: 'Personal Info',
	POLICY_ID: 'Policy ID',
	POLICY_OUTCOME: 'Policy Outcome',
	POPULATED: 'Populated',
	POPULATED_BY: 'Populated By',
	POPULATION_PERCENTAGE: 'Population %',
	POPULATION_PERCENT_LAST_ANALYZED: 'Last Population Analysis Date',
	POTENTIAL_ISSUES: 'Potential Issues',
	POWERED_BY: 'Powered by',
	PRIORITY_PAGE: 'Priority Page?',
	PRIVACY_POLICY: 'Privacy Policy',
	PROCESS_BUILDERS: 'Process Builders',
	PROFILE: 'Profile',
	PUBLIC_LIST: 'Public List',
	PUBLISHED: 'Published',
	QUICK_ACCESS: 'Quick Access',
	QUICK_FIND: 'Quick Find',
	READ: 'Read',
	READ_BY: 'Read By',
	READ_ONLY: 'Read Only',
	READ_REQUESTS_ONLY: 'Read Requests Only',
	REAL_TIME: 'Real Time',
	REAL_TIME_ALERTS_UPSELL: 'Real-Time Alerts Across Your Connected Applications',
	REAL_TIME_ALERTS_UPSELL_LINE1:
		'Don\'t allow unexpected changes to connected apps put your business at risk.',
	REAL_TIME_ALERTS_UPSELL_LINE2:
		// eslint-disable-next-line max-len
		'Create monitors to receive real-time alerts to detect changes to field and object level access, API volume, and system uptime.',
	REAL_TIME_ALERTS_UPSELL_LINE3: 'Contact us today to learn more about Arovy\'s Protect package',
	REAUTHORIZE_SALESFORCE: 'Reauth',
	RECENT_SEARCHES: 'Recent Searches',
	RECENT_SEARCHES_DESCRIPTION: 'Search history will be displayed here for quick access',
	RECIPIENTS: 'Recipients',
	RECOMMENDED_ACTION_TEMPLATES: 'Recommended Action Templates',
	REFERENCES: 'references',
	REFERENCE_COUNT: 'Reference Count',
	REFRESH_DATA: 'Refresh Data',
	RELEASE_NOTES: 'Release Notes',
	REMOVE: 'Remove',
	REMOVE_FROM_INITIATIVE: 'Remove from Initiative',
	REMOVE_ISSUE: 'Remove Issue',
	RENAME: 'Rename',
	REPEAT: 'Repeat',
	REPLACE_BUSINESS_CONTEXT: 'Replace Business Context',
	REPLACE_BUSINESS_CONTEXT_NOTE: 'This will replace your current business context.',
	REPLY_TO: 'Reply To',
	REPORTS: 'Reports',
	REPORTS_CANNOT_BE_FOLLOWED: 'Reports cannot be followed',
	REQUIRED: 'Required',
	RESEND_EMAIL: 'Resend Email',
	RESEND_INVITE: 'Resend Invite',
	RESET: 'Reset',
	RESET_PASSWORD: 'Reset Password',
	RESTORE: 'Restore',
	RETURN: 'Return',
	REVERT: 'Revert',
	REVIEW: 'Review',
	REVOKE: 'Revoke',
	REVOKE_APP_ACCESS: 'Revoke App Access',
	RE_EVALUATE_AFTER_FIELD_CHANGE: 'Re-evaulate after Field Change',
	RULE_CRITERIA: 'Rule Criteria',
	SALESFORCE_LIGHTNING_URLS: 'Salesforce Lightning URLs',
	SALESFORCE_OBJECT_MANAGER: 'Salesforce Object Manager',
	SALESFORCE_ORGS: 'Salesforce Orgs',
	SALESFORCE_REAUTH_REQUIRED: 'Salesforce sync is disabled.',
	SALESFORCE_SETUP: 'Salesforce Setup',
	SALESFORCE_SYNC_FAILURE: 'There was an issue with your latest sync. Please contact support.',
	SALESFORCE_SYNC_IN_PROGRESS: 'Arovy is currently syncing with Salesforce.',
	SALESFORCE_SYNC_SUCCESS: 'Your latest Salesforce sync completed successfully.',
	SAVE: 'Save',
	SAVED_VIEWS: 'Saved Views',
	SAVE_AS_PDF: 'Save as PDF',
	SAVE_FILTERS_AS_NEW_VIEW: 'Save Filters as New View',
	SAVE_NEW_TASK: 'Save New Task',
	SCHEDULED_FOR: 'Scheduled For',
	SCOPE: 'Scope',
	SCOPES: 'Scopes',
	SCOPES_SELECTED: 'scopes selected',
	SCORE_CHANGE: 'Score Change',
	SCORING_CATEGORY: 'Scoring Category',
	SCROLL_TO_ZOOM: 'Ctrl + scroll to zoom',
	SCROLL_TO_ZOOM_OSX: '⌘ + scroll to zoom',
	SEARCH_ACTIONS: 'Search Actions',
	SEARCH_ENTITIES: 'Search Entities',
	SEARCH_FOR_DATA_ACCESS: 'Search for Objects, Users, Profiles, and Permission Sets',
	SEARCH_FOR_OBJECTS: 'Search for Objects',
	SECTION: 'Section',
	SECURITY: 'Security',
	SECURITY_INFO_DESCRIPTION: `Never share your API keys in public repositories or client-side code. 
		Rotate your keys regularly and delete any that are no longer in use.`,
	SECURITY_INFO_TITLE: 'Keep your API keys secure',
	SELECT: 'Select',
	SELECTED: 'Selected',
	SELECT_ADMIN: 'Select Admin',
	SELECT_ALL: 'Select all',
	SELECT_AN_APP: 'Select an App',
	SELECT_AN_APPLICATION: 'Select an Application',
	SELECT_A_TAG: 'Select a tag',
	SELECT_DATE: 'Select Date',
	SELECT_GROUP: 'Select Group',
	SELECT_USER: 'Select User',
	SENDER: 'Sender',
	SEND_INSTRUCTIONS: 'Send Instructions',
	SENSITIVE_FIELDS_FOLLOWED: 'Sensitive Fields Followed',
	SENSITIVE_FIELDS_FOLLOWED_MESSAGE: (count: number) =>
		`You are now following ${count} sensitive fields. Great Job!`,
	SENSITIVITY: 'Sensitivity',
	SENT_AT: 'Sent at',
	SETTINGS: 'Settings',
	SETUP_AUDIT_TRAIL: 'Setup Audit Trail',
	SETUP_AUDIT_TRAIL_EVENT: 'Setup Audit Trail Event',
	SETUP_AUDIT_TRAIL_SUMMARY: 'Setup Audit Trail Summary',
	SETUP_CRITICAL_APPLICATIONS: 'Setup Critical Applications',
	SETUP_CRITICAL_APPLICATIONS_MESSAGE:
		'Maximize the power of Arovy by setting up your critical applications and stay informed and in control.',
	SHOW_HIDDEN: 'Show Hidden',
	SIGN_IN_WITH: (providerName: string) => `Sign In With ${providerName}`,
	SIGN_IN_WITH_SSO: 'Sign In With SSO',
	SLACK: 'Slack',
	SLACK_URL: 'Slack URL',
	SNOOZE: 'Snooze',
	SNOOZED_ISSUES: 'Snoozed Issues',
	SOURCE_IP: 'Source IP',
	SOURCE_NAMESPACE_PREFIX: 'Source Namespace Prefix',
	STAKEHOLDERS: 'Stakeholders',
	STAKEHOLDERS_IMPACTED: 'Stakeholders Impacted',
	STANDARD: 'Standard',
	STATE: 'State',
	STATUS: 'Status',
	STATUS_PAGE_ERROR: 'Status Page Error',
	SUBJECT: 'Subject',
	SUBMIT: 'Submit',
	SUBMITTING: 'Submitting',
	SUBSCRIBE: 'Subscribe',
	SUCCESS: 'Success',
	SUCCESSFULLY_ADDED_TO_INITIATIVE: 'Successfully added to Initiative!',
	SUCCESSFULLY_ADDED_TO_TAG: 'Successfully added to Tag!',
	SUCCESSFULLY_ADDED_TO_TASK: 'Successfully added to Task!',
	SUGGEST: 'Suggest',
	SUMMARIZE: 'Summarize',
	SUMMARY: 'Summary',
	SUPPORT: 'Support',
	SWITCH: 'Switch',
	SYNC: 'Sync',
	SYNC_BEHAVIOR: 'Sync Behavior',
	SYNC_COMPLETED: 'Sync Completed',
	SYNC_IN_PROGRESS: 'Sync in Progress',
	SYNC_NOW: 'Sync Now',
	TAG: 'Tag',
	TAGS: 'Tags',
	TAG_COUNT: 'Tag Count',
	TAG_NAME: 'Tag Name',
	TASK: 'Task',
	TASKS: 'Tasks',
	TASK_NAME: 'Task Name',
	TEAM: 'Team',
	TEMPLATE_TYPE: 'Template Type',
	TERMS_OF_SERVICE: 'Terms of Service',
	TEXT_FIELD_ACTIONS: 'Text Field Actions',
	THANKS_FOR_YOUR_FEEDBACK: 'Thanks for your feedback!',
	THIS_FIELD_HAS: 'This field has',
	TIMELINE: 'Timeline',
	TIMELINE_SUMMARY: 'Timeline Summary',
	TITLE: 'Title',
	TOKENS: 'Tokens',
	TOKEN_COUNT_EXCEEDS_LIMIT: (limit:number) => `Token count exceeds limit of ${limit}`,
	TOKEN_ERROR_TEXT: 'There was an error fetching the Active Tokens for this Application.',
	TOKEN_HELP_TEXT: 'Number of Active Oauth Tokens',
	TOMORROW: 'Tomorrow',
	TOO_MANY_SELECTED: 'Too Many Selected',
	TOTAL: 'Total',
	TOTAL_DATA_SYNC: 'Total Data Synced',
	TOTAL_ENTITIES: 'Total Entities',
	TO_ORGANIZATION: 'To Organization',
	TRACK_ACTIVITIES: 'Track Activities',
	TRACK_FIELD_HISTORY: 'Track Field History',
	TRACK_SETUP_AUDIT_TRAIL_ACTIVITY:
		'Track Setup Audit Trail Activity. For example track when users are granted System Admin profiles.',
	TURN_OFF_STATUS_SYNC: 'Turn Off Status Sync',
	TURN_ON_STATUS_SYNC: 'Turn On Status Sync',
	TYPE: 'Type',
	TYPE_TO_SEARCH: 'Type to Search...',
	UNABLE_TO_UDPATE_MANAGED_SALESFORCE: 'Unable to update due to being part of a managed package.',
	UNABLE_TO_UPDATE_STANDARD_SALESFORCE:
		'Unable to update for standard objects. Please update in Salesforce directly.',
	UNFOLLOW: 'Unfollow',
	UNHIDE: 'Unhide',
	UNKNOWN: 'Unknown',
	UNLOCK_USER: 'Unlock User',
	UNREVIEWED: 'Unreviewed',
	UNSAVED_SUGGESTION: 'Unsaved Suggestion.',
	UNSUPPORTED_FILE_TYPE_GENERIC: 'Unsupported file type.',
	UNSUPPORTED_FILE_TYPE_IMAGE: 'Unsupported file type. Only JPEG and PNG supported.',
	UPDATE: 'Update',
	UPDATED_AT: 'Updated At',
	UPDATED_BY: 'Updated By',
	UPDATE_FILE: 'Update File',
	UPDATE_LINK: 'Update Link',
	UPDATING: 'Updating',
	UPLOAD_AND_ENHANCE: 'Upload & Enhance',
	UPLOAD_FILE_TYPE_HINT: 'PDF, TXT, CSV, DOCX, MD -- file is not stored, only used for extraction',
	UPLOAD_YOUR_PHOTO: 'Upload Your Photo',
	USAGE_ACTIVITY: 'Usage Activity',
	USER: 'User',
	USERNAME: 'Username',
	USERNAME_TO_AUTHENTICATE_WITH: 'Username to authenticate with.',
	USERS: 'Users',
	USERS_IN_PERMISSION_SOURCE: 'Users in Permission Source',
	USER_AGENT: 'User Agent',
	USER_ID: 'User Id',
	USER_INVITATION_OPTIONS: 'User Invitation Options',
	USER_SETTINGS: 'User Settings',
	USER_STATUS: 'User Status',
	VALIDATION_RULE_ISSUES: 'Validation Rule Issues',
	VALUE: 'Value',
	VERSION: 'Version',
	VIEW: 'View',
	VIEW_ALL_DATA: 'View All Data',
	VIEW_ALL_ISSUES: 'View All Issues',
	VIEW_ARCHIVED: 'View Archived',
	VIEW_CONNECTED_APPS_PAGE: 'View Connected Apps Page',
	VIEW_DETAILED_CHANGES: 'View Detailed Changes',
	VIEW_INITIATIVE: 'View Initiative',
	VIEW_IN_SALESFORCE: 'View in Salesforce',
	VIEW_IS_SHAREABLE:
		// eslint-disable-next-line max-len
		'This view is now shareable with a link. Anyone with this link can view the contents of this page, but cannot change any filters or columns.',
	VIEW_POTENTIAL_ISSUES: 'View Potential Issues',
	VIEW_SNOOZED: 'View Snoozed',
	VISIT_ATLASSIAN_HELP_PAGE: 'Visit Atlassian\'s Help Page.',
	WORKFLOW_DETAIL: 'Workflow Detail',
	WORKFLOW_RULE_INFORMATION: 'Workflow Rule Information',
	YES: 'Yes'
};
